import ApiService from "../ApiService";
const {REACT_APP_REST_ENDPOINT} = process.env;

export default class AreeService {

    static getAllAree = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/aree`;
        return ApiService.getRudeRequest(url);
    }

    static getAllSottoaree = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/sottoaree`;
        return ApiService.getRudeRequest(url);
    }

    static createArea = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }
    static findAreeByIdCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/findByIdCorso`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static updateArea = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/update`;
            ApiService.putRequest(resolve, reject, url, data)
        });
     }

    static deleteArea = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/delete`;
            ApiService.delete(resolve, reject, url, data)
        });
     }

    static aggiornaOrdineTree = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/aggiornaOrdineTree`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    }
}